import { render, staticRenderFns } from "./InsightsConsumos.vue?vue&type=template&id=1f9f838f&scoped=true"
import script from "./InsightsConsumos.vue?vue&type=script&lang=js"
export * from "./InsightsConsumos.vue?vue&type=script&lang=js"
import style0 from "./InsightsConsumos.vue?vue&type=style&index=0&id=1f9f838f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f838f",
  null
  
)

export default component.exports